import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmFormsAPI from '../../../api/crm/forms';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getForms(_state) {
        return _state.records;
    },
    getFormById: _state => id => {
        return _state.records.find(f => f.id === Number(id));
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_FORMS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmFormsAPI.get();
            commit(types.SET_CRM_FORMS, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_FORMS_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, data) => {
        commit(types.SET_CRM_FORMS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmFormsAPI.create(data);
            commit(types.ADD_CRM_FORM, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_FORMS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_FORMS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmFormsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_FORM, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_FORMS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_FORMS_UI_FLAG, { isDeleting: true });
        try {
            await CrmFormsAPI.delete(id);
            commit(types.DELETE_CRM_FORM, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_FORMS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_FORMS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_FORMS]: MutationHelpers.set,
    [types.ADD_CRM_FORM]: MutationHelpers.create,
    [types.EDIT_CRM_FORM]: MutationHelpers.update,
    [types.DELETE_CRM_FORM]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
